/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Ask_Import_DescInputs */

const en_ui_onboarding_ask_import_desc = /** @type {(inputs: Ui_Onboarding_Ask_Import_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect intervals.icu or pick your FIT files`)
};

const de_ui_onboarding_ask_import_desc = /** @type {(inputs: Ui_Onboarding_Ask_Import_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu verbinden oder FIT-Dateien wählen`)
};

/**
* | output |
* | --- |
* | "Connect intervals.icu or pick your FIT files" |
*
* @param {Ui_Onboarding_Ask_Import_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_ask_import_desc = /** @type {((inputs?: Ui_Onboarding_Ask_Import_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Ask_Import_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_ask_import_desc(inputs)
	return de_ui_onboarding_ask_import_desc(inputs)
});